module.exports = __webpack_public_path__ + "static/media/cenrad_banner.7be25869.jpg";